import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { communitiesDropdown } from "constants/apiUrls";

interface CommunityType {
  uuid: string;
  name: string;
  isGlobal: boolean;
  cityName: string;
  logo?: string;
  stateShortCode?: string;
  address?: {
  address1?: string;
  city?: string;
  state?: string;
  stateShortCode?: string;
  country?: string;
  countryShortCode?: string;
  zipCode?: string;
  };
}

const communityListApi = createApi({
  reducerPath: "communityList",
  baseQuery: fetchBaseQuery({ baseUrl: "" }),
  endpoints: (builder) => ({
    communityList: builder.query<CommunityType[], void>({
      query: (arg) => {
        const token = localStorage.getItem("token");
        const mandatoryHeaders: any = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
        };

        // Add Authorization header if token exists
        // This endpoint requires authentication
        if (token) {
          try {
            mandatoryHeaders.Authorization = `Bearer ${JSON.parse(token)}`;
          } catch (e) {
            // Failed to parse token
          }
        }

        return {
          url: communitiesDropdown,
          headers: mandatoryHeaders,
        };
      },
      transformResponse: (response: any) => {
        const communities = Array.isArray(response)
          ? response.map((comm: any) => ({
              uuid: comm.uuid,
              name: comm.name,
              isGlobal: comm.isGlobal || false,
              cityName: comm.city,
              logo: comm.logo,
              stateShortCode: comm.stateShortCode,
              address: {
                address1: comm.address1,
                city: comm.city,
                state: comm.state,
                stateShortCode: comm.stateShortCode,
                country: comm.country,
                countryShortCode: comm.countryShortCode,
                zipCode: comm.zipCode,
              },
            }))
          : [];

        return communities;
      },
    }),
  }),
});

export const { useCommunityListQuery, useLazyCommunityListQuery } =
  communityListApi;
export default communityListApi;
